import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { MaintenanceIllustration } from 'src/assets/illustrations';

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  message?: string;
  showHomeButton?: boolean;
};

export function MaintenanceView({
  title = 'Website currently under maintenance',
  message = 'We are currently working hard on this page!',
  showHomeButton = true,
}: Props) {
  return (
    <Box display="flex" alignItems="center" flexDirection="column" sx={{ px: 3, py: 10 }}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        {title}
      </Typography>

      <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>{message}</Typography>

      <MaintenanceIllustration sx={{ my: { xs: 5, sm: 10 } }} />

      {showHomeButton && (
        <Button component={RouterLink} href="/" size="large" variant="contained">
          Go to home
        </Button>
      )}
    </Box>
  );
}
